import type { Dependent, PayerType } from "elephant-web/gql";

export interface PayerBalance {
  total: number;
  paid?: number;
  due?: number;
  waived?: number;
  exempt?: number;
}

export enum FormattedDependentInEnglish {
  MEMBER = "Member",
  DEPENDENT_SPOUSE = "Dependant (Spouse)",
  DEPENDENT_CHILD = "Dependant (Child)",
}

enum GhaneanFormattedDependentInEnglish {
  MEMBER = "Member",
  DEPENDENT_CHILD = "Dependant (< 3 months old)",
}

enum FormattedDependentInFrench {
  MEMBER = "Membre",
  DEPENDENT_SPOUSE = "Dépendant (spouce)",
  DEPENDENT_CHILD = "Dépendant (enfant)",
}

enum GhaneanFormattedDependentInFrench {
  MEMBER = "Membre",
  DEPENDENT_CHILD = "Dépendant (< 3 mois)",
}

type EnumTitles =
  | FormattedDependentInEnglish
  | FormattedDependentInFrench
  | GhaneanFormattedDependentInEnglish
  | GhaneanFormattedDependentInFrench;

export enum InsurerPropType {
  INSURANCE_NUMBER = "insuranceNumber",
  NATIONAL_ID_NUMBER = "nationalIdNumber",
  DEPENDENT = "dependent",
}

export interface InsuranceDetails {
  name?: string;
  membershipNumber?: string;
  insuranceNumber?: string;
  nationalIdNumber?: string;
  dependent?: Dependent;
  schemeName?: string;
}
export interface InsurerProperties {
  name: InsurerPropType;
  title: string;
  enum?: Dependent[];
  enumTitles?: EnumTitles[];
}

export interface ClaimedLineItem {
  lineItemId: string;
  amountInPence: number;
}

export interface Payer {
  id?: string;
  type: string | PayerType;
  name: string;
  balance: PayerBalance;
  insuranceDetails: InsuranceDetails;
  properties: InsurerProperties[];
  claimedLineItems?: ClaimedLineItem[];
}

export interface Insurer {
  id: string;
  insuranceType: string;
  name: string;
  properties: InsurerProperties[];
}
export interface InsurerAccordionProps {
  insurer: Payer;
  index: number;
  handleRemoveInsurer: (index: number) => void;
  insurers: Insurer[];
  invoiceId: string;
}

export interface InsurerAccordionSummaryProps {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}

export interface InsurerDetailsProps {
  insurerType: string;
  insurerProperties: InsurerProperties[];
  index: number;
}

export interface InsurerSummaryProps {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
  insuranceName: string;
  index: number;
}

export interface InsurerDetailsActionsProps {
  deleteInsurer: () => void;
}
